import React from 'react';
import { ErrorMessage } from 'formik';
import LabelR from '../../Simple/LabelR';
import AsyncSimpleSelect from '../../Select/AsyncSimpleSelect';

const AsyncSimpleSelectFormik = (props) => {
  const {
    field: { name, value },
    form: { setFieldValue, setFieldTouched, touched, errors },
    label,
    isDisabled = false,
    required,
    onChange = () => {},
    requiredFields = [name],
  } = props;
  const handleAffectedFields = (affectedFields) => {
    if (affectedFields) {
      Object.keys(affectedFields).forEach(key => setFieldValue(key, affectedFields[key]));
    }
  };

  return (
    <div className="form-group">
      {
        label && (
          required
            ? <LabelR requiredFields={requiredFields} isEditable={!isDisabled} htmlFor={name}>{label}</LabelR>
            : <label htmlFor={name}>{label}</label>
        )
      }
      <AsyncSimpleSelect
        name={name}
        value={value}
        defaultValue={value}
        handleChange={(newValue) => {
          setFieldValue(name, newValue);
          handleAffectedFields(onChange(newValue));
        }}
        handleBlur={() => { setFieldTouched(name, true); }}
        className={`${(errors[name] && touched[name]) ? 'is-invalid' : ''}`}
        {...props}
      />
      {touched[name] && errors[name] && <ErrorMessage name={name} component="div" className="invalid-feedback" />}
    </div>
  );
};

export default AsyncSimpleSelectFormik;
